import React, { useEffect, useState } from 'react';
import {
    View, Text, StyleSheet,
    ScrollView, TouchableHighlight, Pressable
} from 'react-native';
import AppTheme from "../../AppTheme";
import { store } from '../../store/store';
import { getAayuRecommendationPlan } from '../../utils/services/aayu-card/AayuRecommendationFunc';
import { addFontFamilylato, triggerFBQ } from '../../utils/services/CommonUtils';
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils";
import { fbqEventName } from '../../utils/constants/fbqEventName';
import { AayuCardDesign } from '../../utils/widgets/AayuCard/AayuCardDesign';
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { selectedAayuCardForPurcahseSubscription } from '../../utils/services/subject-behaviour/CommonRxjsService';

const AayuCardRecommendation = (props) => {

    const [aayuPlans, updatePlans] = useState({
        recommended: {},
        otherPlans: [{}],
        render: false,
    })

    const [selectedPlan, updateSelectedPlan] = useState({
        aayucardPlan: {},
        index: -1
    })

    function onSelectOption(plan, index) {
        updateSelectedPlan({
            aayucardPlan: plan,
            index: index
        })
    }

    // var recommendedPlansData = {
        
    // }

    useEffect(() => {
        // recommendedPlansData = {
        //     recommended: aayucard[0],
        //     otherPlans: aayucard.splice(1, 2),
        // }
        const recommendedPlansData = getAayuRecommendationPlan(
            props.route.params.aayuPreferences.familyType,
            props.route.params.aayuPreferences.familyProblems,
            props.route.params.aayuPlans
        );
         updateSelectedPlan({
            aayucardPlan: recommendedPlansData.recommended,
            index: -1,
        }); updatePlans({
            recommended: recommendedPlansData.recommended,
            otherPlans: recommendedPlansData.otherPlans,
            render: true
        });
    }, [])

    return (
        <View>
            <View style={{ position: 'fixed', zIndex: 10, backgroundColor: 'white', width: AppTheme.appWidth }}>
                <CommonHeader navigation={props.navigation} title='Plan Recommendation'></CommonHeader>
            </View>

            <ScrollView style={{ backgroundColor: '#fff', marginTop: AppTheme.headerHeight }}>
                {
                    aayuPlans.render ? <View style={{ flex: 1 }}>
                        <Text style={Styles.title}>We found the perfect plan for your family</Text>
                        <Pressable
                            style={{ marginHorizontal: selectedPlan.index == -1 ? 28 : 31.2, marginTop: 12,
                                borderWidth: selectedPlan.index == -1 ? 4 : 1, borderRadius: 5,
                                borderColor: selectedPlan.index == -1
                                    ? AppTheme.color.aayuCardColors.premiumSecondary
                                    : AppTheme.color.grey.disable }}
                            onPress={() => {
                                updateSelectedPlan({
                                    aayucardPlan: aayuPlans.recommended,
                                    index: -1
                                })
                            }}>
                            <AayuCardDesign aayuCardPlan={aayuPlans.recommended} margin={32}/>
                        </Pressable>

                        <Text style={Styles.title}><b>Check Other Plans</b> </Text>
                        <View style={{ height: 8 }} />
                        {
                            aayuPlans.otherPlans.map((plan, index) => {
                                return <Pressable key={index} style={{ marginHorizontal: selectedPlan.index == index ? 28 : 31.2, marginVertical: 8,
                                    borderWidth: selectedPlan.index == index ? 4 : 2, borderRadius: 5,
                                    borderColor: selectedPlan.index == index
                                    ? AppTheme.color.aayuCardColors.premiumSecondary
                                    : AppTheme.color.grey.disable }}
                                    onPress={() => { onSelectOption(plan, index) }}>
                                    <AayuCardDesign aayuCardPlan={plan} margin={32}/>
                                </Pressable>
                            })
                        }
                        <View style={{ height: 8 }} />
                        <Text style={Styles.subTitle}> * All plans can be used for consultation in any category.</Text>

                        <View style={{ shadowOpacity: 0.6, shadowRadius: 4 }}>
                            <TouchableHighlight
                                style={Styles.submit}
                                onPress={() => {
                                    MoengageUtils.trackMoengageEvents('aayu_card_purchase_clicked');
                                    triggerFBQ(fbqEventName.onClick, {
                                        'plan_id': selectedPlan.aayucardPlan['plan'],
                                        'plan_price': selectedPlan.aayucardPlan['discountedPrice'],
                                    });
                                    const reduxState = store.getState()
                                    const isUserLoggedIn = reduxState.isUserLogin ? true : false
                                    if (isUserLoggedIn) {
                                        props.navigation.pop()
                                        props.navigation.pop()
                                        props.navigation.navigate(ScreenRoute.payment_online, { serviceParams: selectedPlan.aayucardPlan, serviceName: 'Aayu Card Subscription' });
                                    } else {
                                        selectedAayuCardForPurcahseSubscription.setSelectedAayuCard({serviceParams: selectedPlan.aayucardPlan, serviceName: 'Aayu Card Subscription'})
                                        props.navigation.pop()
                                        props.navigation.pop()
                                        global.navigateFrom = NavigateFrom.acs_plan_recommender
                                        props.navigation.navigate(ScreenRoute.login);
                                    }
                                }}
                                underlayColor='#fff'>
                                <Text style={Styles.submitText}>NEXT</Text>
                            </TouchableHighlight>
                        </View>
                    </View> : <View />
                }
            </ScrollView>
        </View>)
}

export default AayuCardRecommendation;

const Styles = StyleSheet.create(addFontFamilylato({
    savingsText: { fontSize: 8, color: AppTheme.color.grey.disable },
    title: {
        fontSize: 14,
        fontWeight: '600',
        marginTop: 24,
        marginHorizontal: 16
        // color: '#cc000000'
    },
    subTitle: {
        fontSize: 12,
        color: AppTheme.color.grey.text,
        margin: 24
    },
    submit: {
        margin: 'auto',
        paddingVertical: 12,
        borderRadius: 4,
        backgroundColor: AppTheme.color.primary,
        borderColor: AppTheme.color.primary,
        borderWidth: 1,
        width: AppTheme.appWidth - 32,
        alignItems: "center",
        marginTop: 25,
        // position: "fixed",
        bottom: 8,
    },
    submitText: {
        color: '#fff',
        textAlign: 'center',
        fontWeight: '900',
        fontSize: 14,
    },
    planCard: {
        flex: 1,
        justifyContent: 'space-between',
        padding: 10,
        marginVertical: 12,
        flexDirection: 'row',
        zIndex: 1, shadowOpacity: 0.3, shadowRadius: 5, shadowOffset: {
            height: 1.4,
            width: 1.4
        },
    },
    consultText: {
        fontSize: 20,
        color: '#707070',
        fontWeight: '600'
    },
    validText: {
        fontSize: 10,
        color: '#707070'
    },
    savingText: {
        fontSize: 16,
        color: '#707070'
    },
}))

{/* <View>
                                        <Text style={Styles.consultText}>{plan['consultations']}<Text style={{ fontSize: 14, }}> Consults</Text></Text>
                                        <Text style={Styles.validText}>Validity: {daystomonths(plan['validity'])} Month{ifMultipleMonths(plan['validity'])}</Text>
                                    </View> */}
                                    <View>
                                        {/* <View style={{flex: 1, flexDirection: 'row'}}>
                                        <Text style={[{ color: AppTheme.color.grey.disable, fontSize: 14 }]}>
                                            {IndiaRupee} <Text style={{ textDecorationLine: "line-through" }}>
                                                {plan['originalPrice']}</Text><Text style={{
                                                    color: AppTheme.color.redColor, fontWeight: '600'
                                                }}> {plan['discountedPrice']}</Text></Text>
                                        <Text style={[{
                                            color: AppTheme.color.grey.disable,
                                            textDecorationLine: "line-through", fontSize: 14
                                        }]}> {IndiaRupee} {plan['originalPrice']} </Text>
                                        <Text style={{ fontSize: 14, color: AppTheme.color.redColor, fontWeight: '600', paddingLeft: 4 }}>{plan['discountedPrice']}</Text>
                                    </View> */}
                                        {/* <Text style={[{ color: AppTheme.color.grey.disable, fontSize: 14 }]}>
                                            {IndiaRupee} <Text style={{ textDecorationLine: "line-through" }}>
                                                {plan['originalPrice']}</Text><Text style={{
                                                    color: AppTheme.color.redColor, fontWeight: '600'
                                                }}> {plan['discountedPrice']}</Text></Text>

                                        <Text style={Styles.savingsText}>Savings Rs. {plan['originalPrice'] - plan['discountedPrice']}</Text> */}
                                    </View>
                                    